<i18n>
{
	"en": {
		"ediSearchLable" : "Search for EDI",
		"ediSearchFromDate" : "From date",
		"ediSearchToDate" : "To date",
		"datePlaceholder" : "Create date",
		"inboundEdi" : "Inbound Edi",
		"outboundEdi" : "Outbound Edi",
		"search": "Search",
		"selectEdiDirection_notify_error" : "You have to choose inbound Edi or outbound EDI",
		"selectFromDate_notify_error" : "You have to choose a from date",
		"selectToDate_notify_error" : "You have to choose a to date",
		"ediDirection" : "Innbound / outbound",
		"currentlySearching" : "Searching...."
	},
	"no": {
		"ediSearchLable" : "Søk etter EDI",
		"ediSearchFromDate" : "Fra dato",
		"ediSearchToDate" : "Til dato",
		"datePlaceholder" : "Opprettelses dato",
		"inboundEdi" : "Inngående EDI",
		"outboundEdi" : "Utgående EDI",
		"search": "Søk",
		"selectEdiDirection_notify_error" : "Du må velge om det er utgående eller inngående EDI",
		"selectFromDate_notify_error" : "Du må velge fra dato",
		"selectToDate_notify_error" : "Du må velge til dato",
		"ediDirection" : "Inngående / Utgående EDI",
		"currentlySearching" : "Søker...."
	}
}
</i18n>

<template>
	<t-vertical-panel class="edi-search">
		<div slot="header" class="edi-search-header">
			<t-header-select icon="search" width="100%" :defaultLabel="$t('ediSearchLable')"/>
		</div>
		<div class="edi-search-content"  @keyup.enter="onSearch">
			<t-button
				appearance="primary"
				width="150px"
				:busy="searching"
				@click="onSearch"
			>{{searching ? this.$t('currentlySearching') : this.$t('search')}}</t-button>
			<t-form-group horizontal>
				<t-date-picker
					:label="$t('ediSearchFromDate')"
					:placeholder="$t('datePlaceholder')"
					:dateFormat="displayDateFormat"
					width="100%"
					:value="formatDate(fromDate)"
					relative
					@input="setFromDate"
					@enter="onSearch"
				/>
				<t-date-picker
					:label="$t('ediSearchToDate')"
					:placeholder="$t('datePlaceholder')"
					:dateFormat="displayDateFormat"
					width="100%"
					:value="formatDate(toDate)"
					relative
					@input="setToDate"
					@enter="onSearch"
				/>
			</t-form-group>
			<t-select
				:items="ediDirections"
				:selectedItem="selectedEdiDirection"
				:label="$t('ediDirection')"
				relative
				@change="onChangeEdiDirection"
			/>
		</div>
	</t-vertical-panel>
</template>

<script>

import { displayDateFormat, storageDateFormat, displayDateFormatter } from '@/core';
import { mapActions } from './store/edi.store';
import moment from 'moment';

export default {
	data() {
		return {
			ediDirections: [ this.$t('inboundEdi'), this.$t('outboundEdi') ],
			selectedEdiDirection: this.$t('inboundEdi'),
			fromDate: moment().startOf('day')
				.subtract(7,'d')
				.format(storageDateFormat),
			toDate:  moment().format(storageDateFormat),
			showCriteriaErrorDialog : false,
			searching: false,
		};
	},

	computed: {
		displayDateFormat() {
			return displayDateFormat;
		},
	},
	created() {
		window.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyDown);
	},
	methods: {

		...mapActions([ 'executeGetInboundTransmissions', 'executeGetOutboundTransmissions' ]),
		onChangeEdiDirection(event) {
			this.selectedEdiDirection = event;
		},

		formatDate(date) {
			return displayDateFormatter(date);
		},
		async onKeyDown(event) {
			if (this.searching)
				return;
			if (event.key === 'Enter')
				await this.onSearch();
		},

		setFromDate(fromDate) {
			this.fromDate = moment(fromDate, 'DD.MM.YYYY').format(storageDateFormat);
		},

		setToDate(toDate) {
			this.toDate = moment(toDate, 'DD.MM.YYYY').format(storageDateFormat);
		},

		notify(dictionaryKey) {
			this.$notify({
				type: 'error',
				title: this.$t(dictionaryKey)
			});
		},

		async onSearch() {
			if (!this.selectedEdiDirection) {
				this.notify('selectEdiDirection_notify_error');
				return;
			}

			if (!this.fromDate) {
				this.notify('selectFromDate_notify_error');
				return;
			}

			if (!this.toDate) {
				this.notify('selectToDate_notify_error');
				return;
			}

			let datesPayload = { fromDate: this.fromDate, toDate: this.toDate };
			this.searching = true;
			if (this.selectedEdiDirection === this.$t('inboundEdi'))
				await this.executeGetInboundTransmissions(datesPayload);
			else
				await this.executeGetOutboundTransmissions(datesPayload);

			this.searching = false;
			this.$emit('setComponent', { direction: this.selectedEdiDirection });
		}
	}
};
</script>
<style lang="scss" scoped>
.edi-search{
	background: white;
	.edi-search-header {
		display:flex;
		align-items: center;
		height: 100%;
	}
	.edi-search-content {
		display: grid;
		grid-auto-rows: minmax(min-content, max-content);
		row-gap: 20px;
		background: white; height: 100%;
		min-height: 100%;
		box-sizing: border-box;
		padding: 10px 15px 10px 15px;
	}
	.edi-search-selector {
		display: grid;
		grid-template-columns: 20px 20px;
		column-gap: 5em;
	}
}
</style>